import React, { useEffect, useState, useMemo } from 'react'
import { PDFDownloadLink   } from '@react-pdf/renderer'
import { Spinner } from "react-bootstrap";

// Make sure Invoice is a PDF document built with @react-pdf/renderer primitives
import Invoice from '../NewContractDownload';
 
const Download = ({ data, fileName }) => {
  const [show, setShow] = useState(false);
 
  // Prevent re-renders due to new object identity
  const memoizedData = useMemo(() => data, [data]);

  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), 300); // small delay
    return () => clearTimeout(timeout);
  }, [memoizedData]);

  console.log("memoizedData", memoizedData)
  function convertToStandardTime(timeString) {
    const timeParts = timeString.split(":");
    const hours = parseInt(timeParts[0], 10);
    const minutes = parseInt(timeParts[1], 10);
    const seconds = parseInt(timeParts[2], 10);

    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(seconds);

    return date.toLocaleTimeString(undefined, { hour: "numeric", minute: "numeric", hour12: true });
  }
  return (
    <div className={!show ? 'loading' : ''} title="Save PDF">
      {!show && <Spinner  />}
      {show && (
        <PDFDownloadLink
          document={<Invoice pdfMode={true} data={memoizedData} />}
          fileName={fileName ? `${fileName}.pdf` : 'invoice.pdf'}
          className="text-light"
        >
          Download PDF
        </PDFDownloadLink>
      )}
    </div>
  );
};
export default   Download;

 
//< PDFDownloadLink document={<InvoicePage pdfMode={true}   />} fileName='invoice.pdf' onClick={() => console.log("download")} className="text-light">Download PDF</ PDFDownloadLink>